import { render, staticRenderFns } from "./x-btn-fab.vue?vue&type=template&id=1ce86e20&scoped=true&"
import script from "./x-btn-fab.vue?vue&type=script&lang=js&"
export * from "./x-btn-fab.vue?vue&type=script&lang=js&"
import style0 from "./x-btn-fab.vue?vue&type=style&index=0&id=1ce86e20&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce86e20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
